import { eventTagTitleText } from '../constants/we-spin-event-tags';

export default function EventTypeTitle({ eventType, translations, transparentBg }) {
	return (
		<div className={`event-type-title-bg ${transparentBg ? 'event-type-transparent' : ''}`}>
			<h1 className={`event-type-title-text ${eventType}`}>{eventTagTitleText(eventType, translations)}</h1>
		</div>
	);
}
